<div *ngIf="showModal" id="promptuary-register-modal" class="modal-background">
	<div class="confirmation-modal">
		<div class="header">
			<div class="title">
				{{
					(promptuaryHasTask()
						? 'PROMPTUARY.MODAL.WITH_TASK.TITLE'
						: 'PROMPTUARY.MODAL.TITLE'
					) | translate
				}}
			</div>
			<span class="freud-icon freud-icon-close" (click)="closeModal()"></span>
		</div>
		<div class="info">
			{{
				(promptuaryHasTask()
					? 'PROMPTUARY.MODAL.WITH_TASK.INFO'
					: 'PROMPTUARY.MODAL.INFO'
				)
					| translate
						: {
								name: name ? name : 'Usuário'
						  }
			}}
		</div>

		<div class="zk-mb-4 zk-mt-4 zk-flex zk-flex-col zk-gap-4">
			<service-evolution-quality-banner
				*ngIf="isDefaultPromptuary() && !promptuaryHasTask()"
				mode="modal"
				[quality]="quality"
			></service-evolution-quality-banner>

			<promptuary-quality-description
				*ngIf="isDefaultPromptuary() && !promptuaryHasTask()"
				[isOpen]="false"
			></promptuary-quality-description>

			<promptuary-task-description
				*ngIf="promptuaryHasTask()"
				[description]="promptuary?.task?.description"
				[links]="promptuary?.task?.links"
			>
			</promptuary-task-description>
		</div>

		<div class="buttons-footer">
			<freud-button
				color="secondary"
				(keydown.escape)="closeModal()"
				(click)="closeModal()"
				id="promptuary-cancel-register"
			>
				{{ 'PROMPTUARY.MODAL.CANCEL' | translate }}
			</freud-button>

			<freud-button
				(click)="register()"
				(keydown.enter)="register()"
				id="promptuary-confirm-register"
			>
				{{
					(promptuaryHasTask()
						? 'PROMPTUARY.MODAL.WITH_TASK.CONFIRM'
						: 'PROMPTUARY.MODAL.CONFIRM'
					) | translate
				}}
			</freud-button>
		</div>
	</div>
</div>
